import { create } from "zustand";
import type { PopupPageDto, PopupProductDto } from "@/types/api.types";

interface OptOutPopupStoreState {
  data: PopupPageDto | null;
  selectedProductIds: string[];
  isSubmitting: boolean;
  hydrate: (data: PopupPageDto) => void;
  toggleProduct: (productId: string) => void;
  setSubmitting: (isSubmitting: boolean) => void;
  getSelectedProducts: () => PopupProductDto[];
}

export const useOptOutPopupStore = create<OptOutPopupStoreState>((set, get) => ({
  data: null,
  selectedProductIds: [],
  isSubmitting: false,
  hydrate: (data) =>
    set({
      data,
      selectedProductIds: data.offer_products
        .filter((product) => product.selected)
        .map((product) => product.id),
    }),
  toggleProduct: (productId) =>
    set((state) => {
      const isSelected = state.selectedProductIds.includes(productId);

      return {
        selectedProductIds: isSelected
          ? state.selectedProductIds.filter((id) => id !== productId)
          : [...state.selectedProductIds, productId],
      };
    }),
  setSubmitting: (isSubmitting) => set({ isSubmitting }),
  getSelectedProducts: () => {
    const state = get();

    if (!state.data) {
      return [];
    }

    return state.data.offer_products.filter((product) =>
      state.selectedProductIds.includes(product.id),
    );
  },
}));
